import { Box, Typography } from "@mui/material";
import { FC } from "react";
import { PageHeadingProps } from "../../../portal/src/app/interfaceTypes";
import { supStyle } from "../theme/styleConstants";
import { withTrademark } from "./Tokenizer";

export { withTrademark, withTrademarkTM } from "./Tokenizer";

export const PageHeading: FC<PageHeadingProps> = ({ title, subTitle, variant, marginBottom, color }) => (
  <>
    <Typography sx={{ marginBottom: marginBottom || '10px', color: color || 'inherit', ...supStyle }} variant={variant || 'h4'}>{title}</Typography>

    {subTitle &&
      <Box display='flex'>
        <Typography sx={{ marginBottom: marginBottom || '2rem', ...supStyle }} variant='body1'>{withTrademark(subTitle)}</Typography>
      </Box>
    }
  </>
);
